import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface ConversationMessageDto {
  id?: number;
  conversationId?: number;
  type?: string;
  createDate?: string;
  message?: string;
  senderId?: number;
  senderCode?: string;
  senderName?: string;
  senderAvatar?: string | null;

  // file message
  fileType?: string | null;
  fileUrl?: string | null;
  fileName?: string | null;

  // legacy/optional fields
  groupId?: string;
  clientTempId?: string;
  createdAt?: string;
  fromUser?: string;
  from?: string;
  sender?: string;
}

export interface ConversationListItemDto {
  conversationId?: number;
  groupId?: string;
  userCode?: string;
  userName?: string;
  name?: string;
  avatarUrl?: string;
  lastMessage?: string;
  lastTime?: string;
  unread?: number;
}

export interface AddMessageRequest {
  conversationId: number;
  groupId: string;
  message: string;
  clientTempId: string;
}

@Injectable({ providedIn: 'root' })
export class ChatService {
  constructor(private api: ApiService) {}

  /**
   * Admin: list all conversations
   * GET /api/conversation/list
   */
  listConversations(): Observable<any> {
    return this.api.get<any>('conversation/list');
  }

  /**
   * Load messages by conversationId
   * GET /api/conversation/get?conversationId=...
   */
  getConversation(conversationId: number): Observable<any> {
    return this.api.get<any>('conversation/get', {
      conversationId: conversationId ?? 0,
    });
  }

  /**
   * Send a message
   * POST /api/conversation/add
   */
  addMessage(payload: AddMessageRequest): Observable<any> {
    return this.api.post<any>('conversation/add', payload);
  }

  /**
   * Send a file (image)
   * POST /api/conversation/sendfile (multipart/form-data)
   * Fields: file, conversationId
   */
  sendFile(conversationId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('conversationId', String(conversationId ?? 0));

    return this.api.postFormData<any>('conversation/sendfile', formData);
  }

  /**
   * Delete/clear chat content
   * POST /api/conversation/delete
   */
  deleteConversation(payload: any): Observable<any> {
    return this.api.post<any>('conversation/delete', payload);
  }
}
